<template>
  <div>
    <br />
    <h4 class="mb-10 mt-0">Two-Factor Methods</h4>
    <hr />

    <el-row :gutter="10" style="padding: 15px; 0" class="flex align-center">
      <el-col :xs="2" :sm="2" :lg="1"
        ><i class="el-icon-mobile-phone"></i
      ></el-col>
      <el-col :span="15" :lg="14" :xl="10">
        <p style="margin: 0; font-weight: 600; margin-right: 5px">
          Authenticator App
          <el-tag
            v-if="user.mfaAppVerified"
            class="ml-10"
            type="success"
            size="small"
            >Configured</el-tag
          >
        </p>
        <p style="font-size: 12px; margin: 2px 0 0">
          Use an authentication app or browser extension to get two-factor
          authentication codes when prompted.
        </p></el-col
      >
      <el-col :span="4">
        <div class="flex" style="align-self: flex-start; margin: 0 10px 0 50px">
          <el-button
            type="primary"
            size="small"
            :disabled="appRemoving"
            @click="appModalVisible = true"
            >{{ user.mfaAppVerified ? "Edit" : "Add" }}</el-button
          >

          <el-button
            v-if="user.mfaAppVerified && mode !== 'app'"
            v-loading="appRemoving"
            type="danger"
            size="small"
            :disabled="appRemoving"
            @click="disableMethod('app')"
            >Disable</el-button
          >
        </div>
      </el-col>
    </el-row>
    <hr />
    <el-row :gutter="10" style="padding: 15px; 0" class="flex align-center">
      <el-col :xs="2" :sm="2" :lg="1"><i class="el-icon-message"></i></el-col>
      <el-col :span="15" :lg="14" :xl="10">
        <el-row class="flex align-flex-end">
          <span style="margin: 0; font-weight: 600; margin-right: 5px">
            SMS/Text Message
            <el-tag
              v-if="user.mfaSmsVerified"
              class="ml-10"
              type="success"
              size="small"
              >Configured</el-tag
            >
          </span>
          <span v-if="user.mfaSmsVerified" class="ml-10">{{
            phoneNumberFormatter(mfaPhoneNumber)
          }}</span>
        </el-row>

        <p style="font-size: 12px; margin: 2px 0 0">
          Get a one-time code sent to your phone via SMS to complete
          authentication requests.
        </p></el-col
      >
      <el-col :span="4">
        <div class="flex" style="align-self: flex-start; margin: 0 10px 0 50px">
          <el-button
            size="small"
            type="primary"
            :disabled="smsRemoving"
            @click="smsModalVisible = true"
            >{{ user.mfaSmsVerified ? "Edit" : "Add" }}</el-button
          >
          <el-button
            v-if="user.mfaSmsVerified && mode !== 'sms'"
            v-loading="smsRemoving"
            size="small"
            type="danger"
            :disabled="smsRemoving"
            @click="disableMethod('sms')"
            >Disable</el-button
          >
        </div>
      </el-col>
    </el-row>

    <mfa-sms
      :visible="smsModalVisible"
      @verified="smsModalVisible = false"
      @cancelOperation="smsCancelOperation"
    />

    <mfa-app
      :visible="appModalVisible"
      @verified="appModalVisible = false"
      @cancelOperation="appCancelOperation"
    />
  </div>
</template>

<script>
import MfaSms from "./mfa-sms.vue";
import MfaApp from "./mfa-app.vue";
import { apiV2Host } from "@/feathers/feathers-client";
import { phoneNumberFormatter } from "@/globals/globals";

export default {
  name: "MFAMethods",

  props: { mode: { required: true } },

  components: {
    MfaSms,
    MfaApp,
  },

  data() {
    return {
      smsModalVisible: false,
      appModalVisible: false,
      smsRemoving: false,
      appRemoving: false,
    };
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    },

    mfaPhoneNumber() {
      return this.user.mfaPhoneNumber;
    },
  },

  methods: {
    phoneNumberFormatter,
    smsCancelOperation() {
      this.smsModalVisible = false;
    },

    appCancelOperation() {
      this.appModalVisible = false;
    },

    async refreshUserInfo() {
      try {
        await this.$store.dispatch("auth/authenticate", {
          strategy: "jwt",
          accessToken: this.$store.state.auth.accessToken,
        });
      } catch (_e) {
        //
      }
    },

    async disableMethod(method) {
      const loadingLabel = `${method}Removing`;
      this[loadingLabel] = true;

      const body = {
        mode: method,
      };

      try {
        const res = await fetch(`${apiV2Host}/mfa/auth/disable-mode`, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.auth.accessToken}`,
            Accept: "application/json",
          },
        });

        const json = await res.json();

        const { name, code, message } = json;

        if (code && ["4", "5"].includes(`${code}`[0])) {
          this.$notify({
            title: name,
            message: message,
            type: "error",
          });
          this[loadingLabel] = false;
          return;
        }

        await this.refreshUserInfo();

        this.$notify({
          title: "Success",
          message: `Successfully disabled ${
            method === "sms" ? "SMS / Text message" : "Authenticator App"
          } method`,
          type: "success",
        });

        this[loadingLabel] = false;
      } catch (err) {
        this.$notify({
          title: "Something Went Wrong!",
          message: "Please try again later.",
          type: "error",
        });
        this[loadingLabel] = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-button--small {
  padding: 9px 15px;
  font-size: 12px;
  border-radius: 3px;
}

[class^="el-icon-"] {
  font-size: 28px;

  @media only screen and (max-width: 920px) {
    font-size: 24px;
  }
}
</style>
